import { ChevronDownIcon } from '@radix-ui/react-icons';
import React, { useState, useEffect, useRef } from 'react';

export default function ExpandableText({ label, text }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isClamped, setIsClamped] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        // Check if the content overflows its container
        if (textRef.current) {
            setIsClamped(
                textRef.current.scrollHeight > textRef.current.clientHeight
            );
        }
    }, [text]);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className='py-10'>
            <div>
                <h2 className='md:text-2xl text-xl font-medium font-serif text-prime-950 pb-2'>{label}</h2>
            </div>
            <p
                ref={textRef}
                className={` leading-8 ${
                    isExpanded ? '' : 'line-clamp-4 md:line-clamp-6'
                }`}
                style={{
                    overflow: isExpanded ? 'visible' : 'hidden',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: isExpanded ? 'none' : 6,
                }}
            >
                {text}
            </p>
            {isClamped && (
                <button
                    className="mt-2 text-prime-500 flex gap-1 items-center"
                    onClick={toggleExpand}
                >
                    {isExpanded ? 'Weniger' : 'Mehr'}
                    <ChevronDownIcon />
                </button>
            )}
        </div>
    );
}
